<template>
  <v-app>
    <v-container
      v-if="loadingComplete"
      id="loaded"
    >
      <base-sq-card
        :title="'Batch ' + formatEpoch(item.started_at, 'M/D/YY hh:mm:ss A')"
      >
        <v-row>
          <v-col cols="12">
            Worker: {{ item.worker_name }}
          </v-col>
          <v-col cols="12">
            <v-row>
              <v-card
                style="width:120px"
                class="mx-2"
              >
                <v-sheet
                  class="rounded-0"
                  style="background-color: teal; color: white"
                >
                  <h2
                    class="mx-auto text-center"
                  >
                    Acks
                  </h2>
                </v-sheet>
                <h2 class="mx-auto text-center">
                  {{ acknowledgements.length }}
                </h2>
              </v-card>
              <v-card
                style="width:120px"
                class="mx-2"
              >
                <v-sheet
                  class="rounded-0"
                  style="background-color: teal; color: white"
                >
                  <h2
                    class="mx-auto text-center"
                  >
                    Down
                  </h2>
                </v-sheet>
                <h2 class="mx-auto text-center">
                  {{ stats.downDevicesCount }}
                </h2>
              </v-card>
              <v-card
                style="width:120px"
                class="mx-2"
              >
                <v-sheet
                  class="rounded-0"
                  style="background-color: teal; color: white"
                >
                  <h2
                    class="mx-auto text-center"
                  >
                    Problems
                  </h2>
                </v-sheet>

                <h2 class="mx-auto text-center">
                  {{ stats.problemDevices }}
                </h2>
              </v-card>
              <v-card
                style="width:120px"
                class="mx-2"
              >
                <v-sheet
                  class="rounded-0"
                  style="background-color: teal; color: white"
                >
                  <h2
                    class="mx-auto text-center"
                  >
                    Recovered
                  </h2>
                </v-sheet>
                <h2 class="mx-auto text-center">
                  {{ stats.recoveredDevices }}
                </h2>
              </v-card>
              <v-card
                style="width:120px"
                class="mx-2"
              >
                <v-sheet
                  class="rounded-0"
                  style="background-color: teal; color: white"
                >
                  <h2
                    class="mx-auto text-center"
                  >
                    Dependents
                  </h2>
                </v-sheet>
                <h2 class="mx-auto text-center">
                  {{ stats.removedChildren }}
                </h2>
              </v-card>
            </v-row>
          </v-col>
          <v-col>
            <v-row>
              <v-expansion-panels
                class="mx-2"
              >
<!--                Acks-->
                <v-expansion-panel
                  v-if="acknowledgements.length > 0"
                >
                  <v-expansion-panel-header>
                    <h2>Acknowledgements</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card
                      v-for="(ackNotice) in acknowledgements"
                      :key="ackNotice.id"
                      class="card-full-width"
                    >
                      {{ ackNotice.host_address }} - {{ ackNotice.comment}}
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
                <!--                Down Devices-->
                <v-expansion-panel
                  v-if="stats.downDevicesCount > 0"
                >
                  <v-expansion-panel-header>
                    <h2>Down Devices</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-card
                        v-for="(device, devidx) of calculateDevicesDown"
                        :key="devidx"
                        :class="calculateDeviceClass(device)"
                      >
                        <v-sheet
                          v-if="device && device.parent_down"
                          tile
                          class="mx-2"
                          style="background-color: transparent"
                        >
                        </v-sheet>
                        <v-sheet
                          tile
                          class="mx-2"
                          style="background-color: transparent"
                        >
                          <h3>
                            {{ device.Name }} - <small>
                            <a
                              :href="'http://' + device.NetworkIp"
                              target="_blank"
                            >{{device.NetworkIp}}</a> &middot;
                            <a
                              :href="calculatedIcingaUrl(device.NetworkIp)"
                              target="_blank"
                            >Icinga</a>
                          </small>
                          </h3>
                          Tower: {{ device.tower_number }} - {{ device.tower_name }} <br />
                          Role: {{ device.type_role }} <br />
                          Type: {{ device.type_name }} <br />
                          <span
                            v-if="device && device.parent_down"
                          >
                            <strong>Parent - <small>{{device.ParentNetworkIp}}</small> is down</strong>
                            <br />
                          </span>
                        </v-sheet>
                      </v-card>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!--                Dependent Devices-->
                <v-expansion-panel
                  v-if="stats.removedChildren > 0"
                >
                  <v-expansion-panel-header>
                    <h2>Down Dependents</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-row>
                      <v-card
                        v-for="(device, devidx) of calculateDevicesDependents"
                        :key="devidx"
                        :class="calculateDeviceClass(device)"
                      >
                        <v-sheet
                          v-if="device && device.parent_down"
                          tile
                          class="mx-2"
                          style="background-color: transparent"
                        >
                        </v-sheet>
                        <v-sheet
                          tile
                          class="mx-2"
                          style="background-color: transparent"
                        >
                          <h3>
                            {{ device.Name }} - <small>
                            <a
                              :href="'http://' + device.NetworkIp"
                              target="_blank"
                            >{{device.NetworkIp}}</a> &middot;
                            <a
                              :href="calculatedIcingaUrl(device.NetworkIp)"
                              target="_blank"
                            >Icinga</a>
                          </small>
                          </h3>
                          Tower: {{ device.tower_number }} - {{ device.tower_name }} <br />
                          Role: {{ device.type_role }} <br />
                          Type: {{ device.type_name }} <br />
                          <span
                            v-if="device && device.parent_down"
                          >
                            <strong>Parent - <small>{{device.ParentNetworkIp}}</small> is down</strong>
                            <br />
                          </span>
                        </v-sheet>
                      </v-card>
                    </v-row>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!--                Problem Devices-->
                <v-expansion-panel
                  v-if="stats.problemDevices > 0"
                >
                  <v-expansion-panel-header>
                    <h2>Problem Devices</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card
                      v-for="(device, ip) of problemHosts"
                      :key="ip"
                      class="card-full-width"
                    >
                      <v-sheet
                        tile
                        class="px-3 py-1 problemDeviceHeader"
                      >
                        <h3>
                          {{ device.Name }} - <small>
                          <a
                            :href="'http://' + device.NetworkIp"
                            target="_blank"
                          >{{device.NetworkIp}}</a> &middot;
                          <a
                            :href="calculatedIcingaUrl(device.NetworkIp)"
                            target="_blank"
                          >Icinga</a>
                        </small>
                        </h3>
                        {{ device.type_role }} - {{ device.type_name }}
                      </v-sheet>
                      <v-row>
                        <v-col
                          v-for="(notice, idx) in device.notices"
                          :key="idx"
                          cols="12"
                          class="mx-2"
                        >
                          <p>{{ notice.svc_name }} sensor is {{ notice.svc_state }} with value `{{notice.svc_output}}`</p>
                        </v-col>
                      </v-row>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
<!--                Recovered Devices-->
                <v-expansion-panel
                  v-if="stats.recoveredDevices > 0"
                >
                  <v-expansion-panel-header>
                    <h2>Recovered Devices</h2>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <v-card
                      v-for="(device, ip) of recoveredHosts"
                      :key="ip"
                      class="card-full-width"
                    >
                      <v-sheet
                        tile
                        class="mx-2"
                        style="background-color: transparent"
                      >
                        <h3>
                          {{ device.Name }} - <small>
                          <a
                            :href="'http://' + device.NetworkIp"
                            target="_blank"
                          >{{device.NetworkIp}}</a> &middot;
                          <a
                            :href="calculatedIcingaUrl(device.NetworkIp)"
                            target="_blank"
                          >Icinga</a>
                        </small>
                        </h3>
                        Tower: {{ device.tower_number }} - {{ device.tower_name }} <br />
                        Role: {{ device.type_role }} <br />
                        Type: {{ device.type_name }} <br />
                      </v-sheet>
                    </v-card>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </v-expansion-panels>
            </v-row>
          </v-col>
        </v-row>
      </base-sq-card>
    </v-container>
  </v-app>
</template>

<script>
  import { mapGetters, mapActions } from 'vuex'
  import PublicService from '../../services/public.service'
  import basicMixin from '../../mixins/basic'

  export default {
    name: 'NmBatchSummary',

    components: {
      // PowInvoiceDetails: () => import('@/components/pow/InvoiceDetails'),
    },

    mixins: [basicMixin],
    data: () => ({
      item: {},
      output: {},
      acknowledgements: [],
      downHosts: {},
      problemHosts: {},
      recoveredHosts: {},
      icingaBaseUrl: '',
      stats: {
        problemDevices: 0,
        removedChildren: 0,
        downDevicesCount: 0,
        recoveredDevices: 0,
      },
      loadingComplete: false,
    }),
    computed: {
      ...mapGetters(['isLoggedIn']),
      calculateDevicesDown () {
        const devices = []
        for (const key in this.downHosts) {
          const device = this.downHosts[key]
          if (!device.parent_down) {
            devices.push(device)
          }
        }
        return devices
      },
      calculateDevicesDependents () {
        const devices = []
        for (const key in this.downHosts) {
          const device = this.downHosts[key]
          if (device.parent_down) {
            devices.push(device)
          }
        }
        return devices
      },
    },
    watch: {
    },
    methods: {
      ...mapActions(['login', 'getInvoice']),
      calculatedIcingaUrl (hostname) {
        return this.icingaBaseUrl + `/icingaweb2/monitoring/host/show?host=${hostname}#!/icingaweb2/monitoring/host/services?host=${hostname}`
      },
      // ...mapActions({
      //   getInvoice:
      // })
      calculateDeviceClass (device) {
        let baseClass = 'mx-2'
        if (device && device.parent_down) {
          baseClass += ' parentDown'
        } else {
          baseClass += ' downDevice'
        }
        return baseClass
      },
    },
    // /icingaweb2/monitoring/host/show?host=10.110.0.22#!/icingaweb2/monitoring/host/services?host=10.110.0.22
    async mounted () {
      const queryBatchId = this.$route.query.batch ? this.$route.query.batch : false
      console.log(`BatchId: ${queryBatchId}`)
      try {
        const { data } = await PublicService.getNmBatch(queryBatchId)
        this.item = data
        this.output = data.output_json
        this.icingaBaseUrl = this.output.icingaBaseUrl
        this.stats = data.output_json.stats
        this.acknowledgements = data.output_json.acknowledgements
        this.downHosts = data.output_json.downHosts
        this.problemHosts = data.output_json.problemHosts
        this.recoveredHosts = data.output_json.recoveredHosts
        console.log(this.item)
        this.loadingComplete = true
      } catch (e) {
        console.log(e)
      }
    },
  }
</script>

<style scoped>
  .parentDown {
    background-color: #c2c1c1;
  }
  .downDevice {
    background-color: #f3b9b9;
  }
  .problemDeviceHeader {
    background-color: #fdb074;
  }
</style>
